module.exports = __webpack_public_path__ + "static/media/icon_chat_history.1659afa0.svg";